import getElapsedMinutesOfTheDay from './get-elapsed-minutes-of-day';

export { getElapsedMinutesOfTheDay };

export default getElapsedMinutesOfTheDay;
